<template>
  <div>
    <div>
      <dashboard-header :text="$t('ui.account')"
                        :on-back="routeBack">
      </dashboard-header>
    </div>
    <div class="d-flex justify-center align-center">
      <v-card
          class="p-4 container-card w-75"
          elevation="0"
      >
        <v-row>
          <v-col>
            <p class="text-h6">{{ $t("ui.accountInfo") }}</p>
          </v-col>
          <v-col class="text-right">
            <p class="d-inline text-sub-title-date me-2">{{ $t("ui.start") }}: {{ startDate }}</p>
            <p class="d-inline text-sub-title-date">{{ $t("ui.update") }}: {{ updateDate }}</p>
          </v-col>
        </v-row>
        <data-detail
            :items="items"
            :simple-header="info"
        />
        <v-card
            outlined
            class="pass-card mt-5">
          <p class="p-3 m-0 text-sm-h5 custom-card-head ">{{ $t("ui.changePassword") }}</p>
          <v-divider class="mt-0" style="border-color: #D9D9D9"></v-divider>

          <v-form v-model="isFormValid">
            <div>
              <div class="d-flex">
                <div class="text-h6 mark-title ms-3">*</div>
                <p class="ms-1 text-body-1">{{ $t("ui.newPassword") }}</p>
              </div>
              <v-text-field
                  class="mx-3"
                  v-model="newPassword"
                  outlined
                  dense
                  placeholder="••••••••"
                  :type="passwordType"
                  :rules="rulePassWord"
                  persistent-hint
                  required
              >
                <template v-slot:append>
                  <img
                      style="margin-top: 4px; cursor: pointer"
                      @click="onShowPass"
                      width="16"
                      height="16"
                      :src="
                        passwordType === 'password'
                            ? require('@/assets/images/ic-pw-hide.svg')
                            : require('@/assets/images/ic-pw-show.svg')
                    ">
                </template>

              </v-text-field>

              <div class="d-flex">
                <div class="text-h6 mark-title ms-3">*</div>
                <p class="ms-1 text-body-1">{{ $t("ui.newPasswordAgain") }}</p>
              </div>
              <v-text-field
                  class="mx-3"
                  v-model="newPasswordAgain"
                  outlined
                  dense
                  placeholder="••••••••"
                  :type="passwordAgainType"
                  :rules="rulePassWordAgain"
                  required
              >
                <template v-slot:append>
                  <img
                      style="margin-top: 4px; cursor: pointer"
                      @click="onShowPassAgain"
                      width="16"
                      height="16"
                      :src="
                        passwordAgainType === 'password'
                            ? require('@/assets/images/ic-pw-hide.svg')
                            : require('@/assets/images/ic-pw-show.svg')
                    ">
                </template>
              </v-text-field>
              <!-- <div v-if="validPasswordMsg" style="margin-top: -20px" class="mark-title text-body-2 ms-3">
                {{ validPasswordMsg }}
              </div> -->

              <v-btn
                  :disabled="!isFormValid || !validChangePassword || validPasswordMsg !== ''"
                  @click="onOpenDialogChangePassword"
                  class="ms-3 mt-3 mb-5 no-uppercase"
                  elevation="0"
                  color="info">
                {{ $t("ui.save") }}
              </v-btn>

            </div>
          </v-form>

        </v-card>

      </v-card>

    </div>

    <v-row justify="center">
      <v-dialog
          content-class="card-border-20"
          v-model="showChangePasswordDialog"
          max-width="600px">
        <v-card
            :loading="loading"
            class="card-border-20">
          <v-card-title>
            <span class="text-h6 mt-8 mb-5">{{ $t("ui.enterOtpCode") }}</span>
          </v-card-title>
          <v-container fluid class="px-6">
            <div> {{ $t("ui.noteReceiveOtp") }} {{ email }}</div>

            <v-sheet width="50%" class="mx-auto mt-2">
              <v-otp-input
                  v-model="otpValue"
                  :error="otpError"
                  placeholder="_"
                  length="6"
                  @finish="onConfirmOtp"
                  type="number">

              </v-otp-input>
            </v-sheet>
            <div class="text-body-1 text-valid-error">{{ otpError ? otpErrorMessage : '' }}</div>

            <v-btn
                block
                @click="onConfirmOtp"
                class="no-uppercase"
                elevation="0"
                color="info"
                :disabled="btSendDisabled">
              {{ $t("ui.confirm") }}
            </v-btn>


            <div class="text-body-1 text-center mt-5 mb-10 px-6">
              {{ $t("ui.receiveOtp") }}
              <a class="ms-2 text-blue" @click="sendOtp()"> {{ $t("ui.resendOtp") }} </a>

            </div>

          </v-container>

        </v-card>
      </v-dialog>
    </v-row>

  </div>
</template>

<script>
import {API2} from "../../api";
import {ROLES, TYPE_FORMAT_TIME} from "../../config/constant";
import {mapActions} from "vuex";
import storage from "../../helper/storage";
import routes from "../../routes";
import path from "../../routes/path";
import DashboardHeader from "../component/DashboardHeader";
import DataDetail from "../base/DataDetail";
import mixin from "../../mixin";

export default {
  components: {DataDetail, DashboardHeader},
  mixins: [mixin],
  data() {
    return {
      otpValue: '',
      otpTemp: '',
      otpError: false,
      otpErrorMessage: '',
      email: '',
      detail: {},
      passwordType: 'password',
      passwordAgainType: 'password',
      newPassword: '',
      newPasswordAgain: '',
      showChangePasswordDialog: false,
      isFormValid: false,
    };
  },
  computed: {
    btSendDisabled: function () {
      let otpNotChanged = this.otpValue === this.otpTemp
      return !this.otpValue || otpNotChanged
    },
    info() {
      return this.$t("ui.caption")
    },
    items() {
      return [
        {
          title: this.$t('account.name') + ':',
          data: this.detail.name
        },
        {
          title: this.$t('ui.email') + ':',
          data: this.detail.email
        },
        {
          title: this.$t('ui.phoneNumber') + ':',
          data: this.detail.phoneNumber
        },
      ]
    },
    startDate: function () {
      if (this.detail.createdAt) {
        return this.formatDate(this.detail.createdAt, TYPE_FORMAT_TIME.HH_mm_DD_MM_YYYY)
      }
      return ''
    },
    updateDate: function () {
      if (this.detail.updatedAt) {
        return this.formatDate(this.detail.updatedAt, TYPE_FORMAT_TIME.HH_mm_DD_MM_YYYY)
      }
      return ''
    },
    rulePassWord() {
      return [
        this.newPassword && this.newPassword.length >= 8
        && /[A-Z]/.test(this.newPassword)
        && /[!@#$%^&*(),.?":{}|<>]/.test(this.newPassword)
        && /[0-9]/.test(this.newPassword)
        && !/\s/.test(this.newPassword)
        || this.$t("ui.MSG0051"),
      ]
    },
    rulePassWordAgain() {
      return [
        this.newPasswordAgain === this.newPassword || this.$t('ui.passwordNotMatch'),
        // this.newPasswordAgain && this.newPasswordAgain.length >= 8
        // && /[A-Z]/.test(this.newPasswordAgain)
        // && /[!@#$%^&*(),.?":{}|<>]/.test(this.newPasswordAgain)
        // && /[0-9]/.test(this.newPasswordAgain)
        // && !/\s/.test(this.newPasswordAgain)
        // || this.$t("ui.MSG0039"),
      ]
    },
    validChangePassword: function () {
      return this.newPassword && this.newPasswordAgain
    },
    validPasswordMsg() {
      return this.newPassword === this.newPasswordAgain || this.newPasswordAgain === '' ? '' : this.$t('ui.passwordNotMatch')
    },
    confirm: () => this.$t("ui.confirm"),
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions(["logout"]),
    async getData() {
      this.detail = await this.get(API2.INFO)
    },
    getRole(accountInfo) {
      if (!accountInfo || !accountInfo.roleId) return "";

      switch (accountInfo.roleId.toString()) {
        case ROLES.ADMIN:
          return this.$t("role.admin");
        case ROLES.AGENCY:
          return this.$t("role.agency");
        case ROLES.HOSPITAL_MANAGEMENT:
          return this.$t("role.hospitalManagement");
        default:
          return "";
      }
    },
    async onOpenDialogChangePassword() {
      this.showChangePasswordDialog = true
      await this.sendOtp(true)
    },
    async sendOtp(isInit = false) {
      this.email = ''
      this.otpError = false
      let res = await this.post(API2.SEND_OTP, {
        email: this.detail.email
      }, null, false)
      if (res.data.status !== 200) {
        this.otpError = true
        let error = res.data.error
        if (error.type === 'toast') {
          this.showToast('danger', this.$t("ui.anErrorOccurred"), error.message)
        }
        return
      }
      let data = res.data.data
      this.email = this.detail.email
      if (!isInit) {
        this.showToast('success', this.$t("ui.confirmationCodeSent"), data.message)
      }
    },
    async onConfirmOtp() {
      // console.log("onConfirmOtp value: ", this.otpValue)

      let res = await this.post(API2.CONFIRM_OTP, {
        email: this.detail.email,
        otp: this.otpValue
      }, null, false)

      if (res.data.status !== 200) {
        this.otpError = true
        this.otpValue = this.otpTemp
        let error = res.data.error
        if (error.type === 'toast') {
          this.showToast('danger', this.$t("ui.anErrorOccurred"), error.message)
        } else {
          this.otpValue = ''
          this.otpErrorMessage = error.message
        }
        return
      }
      await this.changePassword()
    },
    async changePassword() {
      let res = await this.put(API2.CHANGE_PASSWORD, {
        email: this.detail.email,
        password: this.newPassword,
        confirmPassword: this.newPasswordAgain,
        otp: this.otpValue
      }, null, false)
      if (res) {
        this.showToast('success', this.$t("ui.changePasswordSuccessful"), this.$t("ui.changePasswordSuccessfulSubtitle"))
        this.onLogout()
      }
    },
    onLogout() {
      this.logout();
      storage.clear();
      routes.push(path.login)
    },
    onShowPass() {
      this.passwordType = this.passwordType === "password" ? "text" : "password";
    },
    onShowPassAgain() {
      this.passwordAgainType = this.passwordAgainType === "password" ? "text" : "password";
    },
  }
};
</script>

<style scoped>


.container-card >>> .text-sm-h5 {
  font-size: 20px !important;
}

.text-sub-title-date {
  color: #00000073;
}

.container-card {
  border-radius: 12px;
}

.pass-card {
  border-radius: 12px;
  border-color: #D9D9D9;
}

.text-blue {
  color: #1890FF !important;
}

.text-valid-error {
  min-height: 24px;
  margin-top: -8px;
  margin-bottom: 20rem;
  text-align: center;
  color: #FF4D4F;
}

.container-card >>> .theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot fieldset {
  color: rgba(217, 217, 217, 1);
}

</style>
